import { defineMessages } from 'react-intl';

import { Switch } from '@sorare/core/src/atoms/inputs/Switch';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Disable3D } from '@sorare/core/src/components/settings/Disable3D';
import { PreferredLanguage } from '@sorare/core/src/components/settings/PreferredLanguage';
import { SettingsSection } from '@sorare/core/src/components/settings/SettingsSection';
import {
  SettingsPage,
  TITLES,
} from '@sorare/core/src/components/settings/pages';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';

import { SettingsWrapper } from '#src/components/settings/SettingsWrapper/index.tsx';

const messages = defineMessages({
  title: {
    defaultMessage: 'Accessibility mode',
  },
  description: {
    defaultMessage:
      'Enable this experimental feature if you have difficulties reading white text on black background',
  },
});

const ExperimentalDarkMode = () => {
  const { lifecycle, update } = useLifecycle();
  const {
    flags: { useLightMode },
  } = useFeatureFlags();
  if (!useLightMode) {
    return null;
  }
  const lightMode = lifecycle?.[LIFECYCLE.experimentalLightMode];
  return (
    <SettingsSection
      title={messages.title}
      description={messages.description}
      toggleButton={
        <Switch
          checked={lightMode}
          onChange={() => {
            update(LIFECYCLE.experimentalLightMode, !lightMode);
          }}
        />
      }
    />
  );
};

export const GlobalPreferences = () => {
  return (
    <SettingsWrapper pageTitle={TITLES[SettingsPage.GLOBAL_PREFERENCES]}>
      <Vertical gap={2}>
        <PreferredLanguage />
        <Disable3D />
        <ExperimentalDarkMode />
      </Vertical>
    </SettingsWrapper>
  );
};

export default GlobalPreferences;
